import { Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { cn } from '@/utils/cn';

import { useReportFavorites, type ReportFavoriteRef } from './report-favorites';

interface ReportFavoriteButtonProps {
  favoriteRef: ReportFavoriteRef;
  churchId: string | undefined;
  userId: string | undefined;
  className?: string;
  size?: 'sm' | 'md';
}

export const ReportFavoriteButton = ({
  favoriteRef,
  churchId,
  userId,
  className,
  size = 'sm',
}: ReportFavoriteButtonProps) => {
  const { t } = useTranslation('reports');
  const { isFavorite, toggleFavorite } = useReportFavorites(churchId, userId);
  const active = isFavorite(favoriteRef);

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn('shrink-0 self-center', size === 'sm' ? 'size-8' : 'size-9', className)}
      aria-label={active ? t('favorites.remove') : t('favorites.add')}
      aria-pressed={active}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        toggleFavorite(favoriteRef);
      }}
    >
      <Star
        className={cn('size-4', active ? 'fill-brand text-brand' : 'text-fg-tertiary')}
        aria-hidden
      />
    </Button>
  );
};
